import { useContext } from 'react'
import { createGroupId } from '../helpers'
import GalleryContext from '../gallery-context'

const useGalleryNavigation = () => {
  const { basePath } = useContext(GalleryContext)

  const createPath = (group, subgroup = '') => {
    return [basePath, ...[group, subgroup].map(createGroupId)]
      .filter(p => !!p)
      .join('/')
  }

  return { createPath }
}

export default useGalleryNavigation
